import { motion } from "framer-motion";
import styled from "styled-components";
import { pageAnimation } from "../animation";
import { primaryColor } from "../components/GlobalStyle";

const ErrorPage = () => {
  return (
    <ErrorContainer
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      exit="exit"
    >
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>
        The page you are looking for does not exist or an error has occurred.
      </p>
      <HomeLink href="/">Go to Home</HomeLink>
    </ErrorContainer>
  );
};

const ErrorContainer = styled(motion.div)`
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  padding: 4rem 2rem;

  h1 {
    font-size: 8rem;
    color: ${primaryColor};
    margin-bottom: 1rem;
  }
  h2 {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  }
  p {
    font-size: 1.2rem;
    margin-bottom: 2.5rem;
    color: #cccccc;
  }
`;

const HomeLink = styled.a`
  display: inline-block;
  padding: 0.8rem 2rem;
  background: ${primaryColor};
  color: #fff;
  border-radius: 30px;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.1rem;
  transition: background 0.2s;
  &:hover {
    background: #1b1b1b;
    color: ${primaryColor};
    border: 1px solid ${primaryColor};
  }
`;

export default ErrorPage;
